<template>
  <div class="row" :key="componentKey">
    <div class="col col-md-12">
      <div class="rowLista" style="margin-top: 10px">
        <div
          class=""
          v-for="(item, itemIndex) in itensExibidos"
          :key="item.id"
          :item="item"
        >
          <div
            class="list-group-item d-flex justify-content-start"
            style="
              padding-top: 2px;
              padding-bottom: 4px;
              padding-left: 10px;
              margin-top: 10px;
              background-color: rgb(116 121 129);
            "
            v-if="
              itemIndex == 0 ||
              itensExibidos[itemIndex - 1].competicao !== item.competicao
            "
          >
            <span>
              <img
                :src="item.competicaoPaisUrl"
                height="20"
                alt="Brazil"
                style="max-height: 15px; border: solid 1px; margin-top: 0px"
                v-if="retornaSite() !== 'Share'"
              />
            </span>
            <h6
              v-if="item.competicao && item.competicao !== ''"
              class="text-left"
              style="
                margin: 0px;
                padding: 0px;
                margin-top: 6px;
                margin-left: 5px;
                font-size: 14px;
                color: white;
              "
            >
              <small
                ><strong>{{ item.competicao }}</strong></small
              >
            </h6>
          </div>
          <div
            class="list-group-item text-left"
            style="border-top: 0; padding-top: 5px; padding-bottom: 5px"
          >
            <div class="row">
              <div
                class="col text-center align-middle"
                style="
                  padding-top: 0px;
                  padding-bottom: 0px;
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 70px;
                  min-width: 70px;
                "
                v-if="retornaSite() !== 'Share'"
              >
                <div>
                  <small> {{ formatarHora(item) }}</small>
                </div>
                <div v-if="item.situacao == 3" class="text-danger fs-bold">
                  <small><strong>Ao Vivo</strong></small>
                </div>
                <div v-if="item.situacao == 1" class="text-secondary">
                  <small>Previsto</small>
                </div>
              </div>
              <div
                class="col d-flex align-self-center"
                style="padding-top: 2px; padding-bottom: 0px; padding-left: 0px"
              >
                <div class="d-flex justify-content-start">
                  <span style="padding-top: 1px; padding-right: 8px" v-if="retornaSite() !== 'Share'">
                    <button
                      class="favorito"
                      :class="{
                        ativo: itensFavoritos[item._id] ? true : false,
                      }"
                      @click="favorito(item)"
                    >
                      <i
                        class="fa"
                        :class="{
                          'fa-star-o': itensFavoritos[item._id] ? false : true,
                          'fa-star': itensFavoritos[item._id] ? true : false,
                        }"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </span>
                  <span>{{ item.nome }}</span>
                </div>
              </div>
              <div
                class="col-2 d-flex align-self-center justify-content-end"
                style="padding-top: 0px; padding-bottom: 0px"
              >
                <div
                  style="margin-top: 0px"
                  v-if="
                    item.situacao == 3 ||
                    retornaTipoUsuario() == 'Administrador' ||
                    retornaTipoUsuario() == 'Apresentador'
                  "
                >
                  <button
                    v-if="retornaSite() !== 'Share'"
                    type="button"
                    @click="abrirEvento(item, false)"
                    class="btn btn-sm btn-success mb-2 mb-md-0 mr-0 mr-md-2"
                    style="font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Com radar"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-bar-chart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    v-if="retornaSite() !== 'Share'"
                    type="button"
                    @click="abrirEvento(item, true)"
                    class="btn btn-sm btn-success"
                    style="font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Sem radar"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-easel"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    v-if="retornaSite() == 'Share'"
                    type="button"
                    @click="abrirEvento(item, true)"
                    class="btn btn-sm btn-success"
                    style="font-size: 10px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="View"
                  >
                    <span>View</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h1 class="tituloJogos" v-if="retornaSite() !== 'Share'">Encerrados</h1>

        <p
          v-if="
            itensEncerradosExibidos.length == 0 && retornaSite() !== 'Share'
          "
          style="margin-bottom: 0px"
        >
          ------
        </p>

        <div
          class=""
          v-for="(item, itemIndex) in itensEncerradosExibidos"
          :key="item.id"
          :item="item"
        >
          <div
            class="list-group-item d-flex justify-content-start"
            style="
              padding-top: 2px;
              padding-bottom: 4px;
              padding-left: 10px;
              margin-top: 10px;
              background-color: rgb(116 121 129);
            "
            v-if="
              itemIndex == 0 ||
              itensEncerradosExibidos[itemIndex - 1].competicao !==
                item.competicao
            "
          >
            <span>
              <img
                :src="item.competicaoPaisUrl"
                height="20"
                alt="Brazil"
                style="max-height: 15px; border: solid 1px; margin-top: 1px"
              />
            </span>
            <h6
              v-if="item.competicao && item.competicao !== ''"
              class="text-left"
              style="
                margin: 0px;
                padding: 0px;
                margin-top: 6px;
                margin-left: 5px;
                font-size: 14px;
                color: white;
              "
            >
              <small
                ><strong>{{ item.competicao }}</strong></small
              >
            </h6>
          </div>
          <div
            class="list-group-item text-left"
            style="border-top: 0; padding-top: 5px; padding-bottom: 5px"
          >
            <div class="row">
              <div
                class="col text-center align-middle"
                style="
                  padding-top: 0px;
                  padding-bottom: 0px;
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 70px;
                  min-width: 70px;
                "
                v-if="retornaSite() !== 'Share'"
              >
                <div>
                  <small> {{ formatarHora(item) }}</small>
                </div>
                <div v-if="item.situacao == 4" class="text-dark">
                  <small>Encerrado</small>
                </div>
              </div>
              <div
                class="col d-flex align-self-center"
                style="padding-top: 2px; padding-bottom: 0px; padding-left: 0px"
              >
                <div class="d-flex justify-content-start">
                  <span style="padding-top: 1px; padding-right: 8px" v-if="retornaSite() !== 'Share'">
                    <button
                      class="favorito"
                      :class="{
                        ativo: itensFavoritos[item._id] ? true : false,
                      }"
                      @click="favorito(item)"
                    >
                      <i
                        class="fa"
                        :class="{
                          'fa-star-o': itensFavoritos[item._id] ? false : true,
                          'fa-star': itensFavoritos[item._id] ? true : false,
                        }"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </span>
                  <span>{{ item.nome }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

export default {
  name: "ListEventosHome2",
  components: {},
  props: {
    itensLimit: { type: Number, default: 300 },
    aovivo: { type: Boolean, default: false },
    busca: { type: String, default: "" },
    competicoesSelecionadas: { type: Array, default: () => [] },
    ordenacao: { type: String, default: "competicao" },
    propSite: { type: String, default: "" },
    gmt: { type: Number, default: -3 },
    propFavorito: { type: Boolean, default: false },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao.usuario.tipoUsuario;
    },
    usuarioAdministrador() {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Administrador Site"
      );
    },
    normalizarTexto(valor) {
      return (valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    },
    minutosEvento(item) {
      var hora = Number(item.dataHora);
      var minuto = Number(item.dataMinuto);

      if (Number.isNaN(hora) || Number.isNaN(minuto)) {
        return Number.MAX_SAFE_INTEGER;
      }

      return ((hora + 3 + Number(this.gmt) + 24) % 24) * 60 + minuto;
    },
    compararEventos(a, b) {
      if (this.ordenacao == "competicao") {
        var comparacaoCompeticao = (a.competicao || "Sem competição").localeCompare(
          b.competicao || "Sem competição",
          "pt-BR"
        );

        if (comparacaoCompeticao !== 0) {
          return comparacaoCompeticao;
        }
      }

      return (
        this.minutosEvento(a) - this.minutosEvento(b) ||
        (a.nome || "").localeCompare(b.nome || "", "pt-BR")
      );
    },
    filtrarOrdenarEventos(itens) {
      var termo = this.normalizarTexto(this.busca);

      return itens
        .filter(
          (item) =>
            this.competicoesSelecionadas.includes(
              item.competicao || "Sem competição"
            ) &&
            (!termo ||
              this.normalizarTexto(item.nome).includes(termo) ||
              this.normalizarTexto(item.competicao).includes(termo))
        )
        .slice()
        .sort(this.compararEventos);
    },
    formatarHora(evento) {
      var hora = evento.dataHora.toString().padStart(2, "0");
      var minuto = evento.dataMinuto.toString().padStart(2, "0");

      try {
        var data = new Date();
        data.setHours(evento.dataHora + 3 + this.gmt);
        data.setMinutes(evento.dataMinuto);

        hora = data.getHours();
        minuto = data.getMinutes();
      } catch (err) {
        console.log(err);
      }

      return (
        hora.toString().padStart(2, "0") +
        ":" +
        minuto.toString().padStart(2, "0")
      );
    },
    async carregarItens() {
      var filtros = "";

      filtros += "?_limit=" + this.itensLimit;

      //* Verifica se foi especificado o site
      if (this.propSite !== "") {
        filtros = filtros + "&site=" + this.propSite;
      }

      let itensFavoritosTemp = {};

      try{

        if(this.retornaSite() !== "Share"){

          //* Carrega os favoritos
          const responseFavorito = await api.get("/favorito");

          //* Verifica se carregou
          if (responseFavorito.data.erro == false) {
            //* Percorre os itens
            for (
              let indiceFavorito = 0;
              indiceFavorito < responseFavorito.data.itens.length;
              indiceFavorito++
            ) {
              itensFavoritosTemp[
                responseFavorito.data.itens[indiceFavorito].evento
              ] = responseFavorito.data.itens[indiceFavorito];
            }
          }
          
        }

      }catch(err){
        console.log(err);
      }

      //* Atualiza os novos itens
      this.itensFavoritos = itensFavoritosTemp;

      var routeEvento = "/evento";

      if (
        this.$sessao &&
        this.$sessao.usuario &&
        Object.keys(this.$sessao.usuario).includes("tipoUsuario") &&
        this.$sessao.usuario.tipoUsuario == "Assinante"
      ) {
        routeEvento = "/evento/cache";
      }

      const response = await api.get(routeEvento + filtros);
      api.valid(response.data, this.$router);

      if (
        this.$sessao &&
        this.$sessao.usuario &&
        Object.keys(this.$sessao.usuario).includes("gmt")
      ) {
        this.gmt = this.$sessao.usuario.gmt;
      }

      var arrEventos = [];
      var arrEventosPrevisto = [];
      var arrEventosEncerrados = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        var inserir = false;

        if (this.propSite !== "") {
          if (item.site == this.propSite) {
            inserir = true;
          }
        } else {
          if (item.site !== "Extra") {
            inserir = true;
          }
        }

        //* Define o pais padrao
        item.competicaoPais = "";

        //* Define o pais pela competicao
        if (item.competicao && item.competicao !== "") {
          let arrCompeticao = item.competicao.split(",");

          if (arrCompeticao.length > 0) {
            item.competicaoPais = util
              .countryNameToCode(arrCompeticao[0])
              .toLowerCase();
          }
        }

        item.competicaoPaisUrl =
          item.competicaoPais == ""
            ? "/assets/worldflag3.png"
            : "https://flagcdn.com/h20/" + item.competicaoPais + ".png";

        if (
          this.propFavorito == false ||
          (this.propFavorito == true && itensFavoritosTemp[item._id])
        ) {
          if (inserir) {
            if (item.situacao == 4) {
              arrEventosEncerrados.push(item);
            } else {
              if (item.situacao === 3) {
                arrEventos.push(item);
              } else if (item.situacao === 1) {
                arrEventosPrevisto.push(item);
              }
            }
          }
        }
      }

      this.itens = arrEventos.concat(arrEventosPrevisto);
      this.itensEncerrados = arrEventosEncerrados;
      this.$emit(
        "eventos-carregados",
        this.itens.concat(this.itensEncerrados)
      );
    },
    favorito(item) {
      if (this.itensFavoritos[item._id]) {
        delete this.itensFavoritos[item._id];
        api.put("/favorito", { evento: item._id });
      } else {
        this.itensFavoritos[item._id] = true;
        api.post("/favorito", { evento: item._id });
      }

      this.forceRerender();

      var thisCall = this;

      if (this.timeoutCarregarItens !== null) {
        clearTimeout(this.timeoutCarregarItens);
      }

      this.timeoutCarregarItens = null;

      this.timeoutCarregarItens = setTimeout(function () {
        thisCall.carregarItens();
      }, 2000);
    },
    abrirEvento(item, limpo) {
      var url = "/view/" + item._id;

      if (limpo) {
        url = url + "?view=clean";
      }

      if (
        item.situacao == 3 ||
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      ) {
        window.open(
          url,
          "newwindow_" + Date.now(),
          "scrollbars=1,width=450,height=690",
          true
        );
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
  mounted() {
    this.carregarItens();
  },
  computed: {
    itensExibidos() {
      return this.filtrarOrdenarEventos(this.itens);
    },
    itensEncerradosExibidos() {
      return this.filtrarOrdenarEventos(this.itensEncerrados);
    },
  },
  data: function () {
    return {
      itens: [],
      itensEncerrados: [],
      itensFavoritos: {},
      timeoutCarregarItens: null,
      componentKey: 1,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
